module.exports = __webpack_public_path__ + "c336e69b4b8b04cc74822e88360e08b2.svg";